import { SVGProps } from "react";

const Export = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.8335 9.16666L17.6668 2.33333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3335 5.66667L18.3335 1.66667L14.3335 1.66667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.1665 1.66667L7.49984 1.66667C3.33317 1.66667 1.6665 3.33334 1.6665 7.5L1.66651 12.5C1.66651 16.6667 3.33317 18.3333 7.49984 18.3333L12.4998 18.3333C16.6665 18.3333 18.3332 16.6667 18.3332 12.5L18.3332 10.8333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Export;
